import React from 'react'
import './testimonials.css'
import AVTR1 from '../../assets/avatar1.jpg'
import AVTR2 from '../../assets/avatar2.jpg'
import AVTR3 from '../../assets/avatar3.jpg'
import AVTR4 from '../../assets/avatar4.jpg'

// import Swiper core and required modules
import { Navigation, Pagination} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const data = [
  {
    avatar: AVTR1,
    name: 'Mrs BEATRICE ANGO',
    review:  "I am thrilled with the website that the development team created for me. They were able to capture the essence of my business and create a site that is both visually stunning and user-friendly. Throughout the process, they were professional, responsive, and easy to work with. I highly recommend their services to anyone looking for a high-quality website."
  },
  {
    avatar: AVTR2,
    name: 'Mrs GOGOLINA OLGA',
    review:  "The development team exceeded my expectations with their work on my website. They took the time to understand my business and my vision, and they delivered a site that is not only beautiful but also functional and easy to navigate. Their attention to detail and commitment to excellence are evident in every aspect of the site. I would highly recommend them to anyone looking for a top-notch website."
  },
  {
    avatar: AVTR3,
    name: 'Mr BIYIHA LUC',
    review: "I couldn't be happier with the website that the development team created for me. They were able to take my ideas and turn them into a stunning website that perfectly represents my brand. Their expertise and attention to detail are evident in every aspect of the site, and they were a pleasure to work with throughout the entire process. I highly recommend their services to anyone looking for a top-quality website."
  },
  {
    avatar: AVTR4,
    name: 'Mr TABI AHANDA',
    review: "The development team did an outstanding job on my website. They were able to create a site that is not only visually appealing but also highly functional and easy to use. Their expertise and attention to detail are evident in every aspect of the site, and they were a pleasure to work with throughout the entire process. I would highly recommend them to anyone looking for a high-quality website."
  }
]

const Testimonials = () => {
  return (
    <section id='testimonials'>
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper className="container testimonials__container"
      // install Swiper modules
      modules={[Navigation, Pagination]}
      spaceBetween={40}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}>
        {
          data.map(({avatar, name, review}, index) => {
            return (
              <SwiperSlide key={index} className='testimonial'>
                <div className="client__avatar">
                  <img src={avatar} />
                </div>
                <h5 className='client__name'>{name}</h5>
                  <small className='client__review'>{review}</small>
              </SwiperSlide>
            )
          })
        }
      </Swiper>
    </section>
  )
}

export default Testimonials